import React, { useState } from "react";
import { connect } from "react-redux";
import { login, resetPassword } from "../actions/auth";
import { Form, } from 'react-bootstrap';
import alertify from 'alertifyjs';

import "./auth.css";


// export default (props) => {
function Login(props) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [cnfPassword, setCnfPassword] = useState("");
  const [validated, setValidate] = useState(false);
  // console.log(cnfPassword);

  const submitForm = (event) => {
    event.preventDefault()
    if (email === "" || password === "") {
      console.log("Fields are required");
      return;
    }
    props.login({ email, password });

  };

  const submitResetForm = (e) => {
    e.preventDefault()
    e.stopPropagation();
    if (newPassword !== cnfPassword || newPassword === '') {
      setValidate(false);
      alertify.error('Passwords did not match.')
      return;
    } else {
      props.resetPassword({ newPassword, email });
    }

  };
  return (
    <div className="auth-body ">
      <div className="auth-wrapper">
        <div className="auth-inner">
          <h3>Sign In</h3>
          <Form noValidate validated={validated}>

            <Form.Group className="form-group">
              <Form.Label htmlFor="sign_email">Email address</Form.Label>
              <Form.Control required id="sign_email" type="email" className="form-control" placeholder="Enter email" onChange={e => setEmail(e.target.value)} />
            </Form.Group>

            <Form.Group className="form-group">
              <Form.Label htmlFor='sign_pass'>Password</Form.Label>
              <Form.Control required id='sign_pass' type="password" className="form-control" placeholder="Enter password" onChange={e => setPassword(e.target.value)} />
            </Form.Group>
            {props.passwordResetRequired ?
              <div>
                <Form.Group className="form-group">
                  <Form.Label htmlFor='new_pass'>New Password</Form.Label>
                  <Form.Control id='new_pass' type="password" className="form-control" placeholder="Enter password" onChange={e => setNewPassword(e.target.value)} />
                  <Form.Text >
                    Mix password with upper case, lower case, number and special character.
                  </Form.Text>
                </Form.Group>

                <Form.Group className="form-group">
                  <Form.Label htmlFor='cnf_pass'>Retype Password</Form.Label>
                  <Form.Control id='cnf_pass' type="password" className="form-control" placeholder="Enter password" onChange={e => setCnfPassword(e.target.value)} />
                </Form.Group>
                <button className="btn btn-primary btn-block" onClick={submitResetForm}>Reset password</button>
              </div> :
              <div>
                <button className="btn btn-primary btn-block" onClick={submitForm}>Login</button>
                {/* <p className="forgot-password text-right">
                  Forgot <a href="/dummy">password?</a>
                </p> */}
              </div>
            }
          </Form>
        </div>
      </div>
    </div>
  );

};


const mapStateToProps = ({ reducer: store }) => ({
  passwordResetRequired: store.passwordResetRequired
});

export default connect(mapStateToProps, { login, resetPassword })(Login);